<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.5 0H2.5C1.12 0 0 1.12 0 2.5V18.5C0 19.88 1.12 21 2.5 21H18.5C19.88 21 21 19.88 21 18.5V2.5C21 1.12 19.88 0 18.5 0ZM15.355 14.645L14.645 15.355L10.5 11.21L6.355 15.355L5.645 14.645L9.79 10.5L5.645 6.355L6.355 5.645L10.5 9.79L14.645 5.645L15.355 6.355L11.21 10.5L15.355 14.645Z"
            fill="#394E5B"
        />
    </svg>
</template>
